import { CanvasSize, CanvasTheme, ViewportMatrix } from '@/types';

import { FULL_HD_DIMENSION } from './CommonConstants';

export const BACKGROUND_OVERLAY = 'background-overlay';

export const CANVAS_CONTAINER_ID = 'canvas-wrapper';
export const CANVAS_SIZE: CanvasSize = {
  width: 1922,
  height: 1080
};
export const CANVAS_SCALE_MARGIN = 0.99;

export const DEFAULT_OPACITY = 0;
export const DEFAULT_CANVAS_SIZE: CanvasSize = {
  width: FULL_HD_DIMENSION.WIDTH,
  height: FULL_HD_DIMENSION.HEIGHT
};

export const DEFAULT_CANVAS_FONT_SIZE = 48;
export const DEFAULT_CANVAS_FONT_COLOR = '#000000FF';
export const DEFAULT_CANVAS_TEXTBOX_WIDTH = 600;

export const CANVAS_OBJECT_TYPE = {
  TEXTBOX: 'textbox',
  IMAGE: 'image'
};

export const DEFAULT_CANVAS_JSON = {
  width: DEFAULT_CANVAS_SIZE.width,
  height: DEFAULT_CANVAS_SIZE.height,
  backgroundColor: '#00000000'
};

export const CANVAS_THEME_CONFIG: CanvasTheme = {
  canvas: { backgroundColor: '#FFFFFF' },
  clipImage: { maxWidth: 900, maxHeight: 750, left: -50, top: 240 },
  text: {
    width: 750,
    height: 120,
    textColor: '#000000',
    textAlign: 'left',
    lineHeight: 0.7,
    fontSize: 60,
    fontFamily: 'Roboto Serif',
    fontWeight: 400,
    left: 530,
    top: 710
  },
  textSecondary: {
    width: 750,
    height: 120,
    lineHeight: 0.7,
    textColor: '#000000',
    textAlign: 'left',
    fontSize: 60,
    fontFamily: 'Roboto Serif',
    fontWeight: 400,
    left: 530,
    top: 700
  }
};

export const CANVAS_SNAP_THRESHOLD = 20;
export const CANVAS_GUIDELINE_COLOR = '#1890ff';
export const CANVAS_GUIDELINE_LINE_WIDTH = 1;

export const DEFAULT_CANVAS_VIEWPORT_TRANSFORM: ViewportMatrix = [1, 0, 0, 1, 0, 0];

export const DEFAULT_CANVAS_CONTENT_JSON = {
  ...DEFAULT_CANVAS_JSON,
  viewportTransform: DEFAULT_CANVAS_VIEWPORT_TRANSFORM
};
